import { reduxKey } from './constants';
export var getFirstTimeFlags = function (state) {
    return state[reduxKey] || {};
};
export var hasFirstTimeFlag = function (state, flag) {
    return Boolean(getFirstTimeFlags(state)[flag]);
};
//# sourceMappingURL=selectors.js.map